module.exports = "/assets/hero-rw@2x.jpg?dj1E3Xv";